import Main from './Main'

export default {
  Main
}



// WEBPACK FOOTER //
// ./src/components/Community/Settings/index.js